import type { IOrganizationFeatureClientPortalSystem } from './OrganizationFeatureClientPortalSystem.interface';
import OrganizationFeatureClientPortalSystemInvite from './OrganizationFeatureClientPortalSystemInvite';

export default class OrganizationFeatureClientPortalSystem
  implements IOrganizationFeatureClientPortalSystem {
  invite: OrganizationFeatureClientPortalSystemInvite;

  static build = (data: IOrganizationFeatureClientPortalSystem) =>
    new OrganizationFeatureClientPortalSystem(data);
  static blank = () => new OrganizationFeatureClientPortalSystem();

  /**
   * Constructor
   * @param {IOrganizationFeatureClientPortalSystem} data
   */
  constructor(data?: IOrganizationFeatureClientPortalSystem) {
    this.invite = new OrganizationFeatureClientPortalSystemInvite(data?.invite);
  }
}
